import { CatalogEntityType } from "../../Catalog/types";
import { InfoItem, hasValue } from "../components/detailLayout";

export const segmentForType = (type: CatalogEntityType): string =>
  type === "course" ? "courses" : type === "path" ? "paths" : "activities";

export const showAdditionalInfo = (
  info1: InfoItem[],
  info2: InfoItem[],
  info3: InfoItem[],
  info4: InfoItem[],
) =>
  [info1, info2, info3, info4].some((items) =>
    items.some((i) => hasValue(i.value)),
  );
